import { messages } from '@system/translations/index'

type Translations = {
  [key: string]: string
}

export function useTranslations(lang: string): Translations {
  return messages[lang]
}
